import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-with-sidebar-container',
  templateUrl: './page-with-sidebar-container.component.html',
  styleUrls: ['./page-with-sidebar-container.component.scss']
})
export class PageWithSidebarContainerComponent implements OnInit {

  @Input() class: string;

  constructor() { }

  ngOnInit(): void {
  }

}
